import { useField } from 'formik';
import { useEffect } from 'react';

type IProps = {
	label: string;
	name: string;
	disabled?: boolean;
};
const Checkbox = (props: IProps) => {
	const { label, name, disabled } = props;
	const [field, meta, helpers] = useField(name);
	useEffect(() => {
		helpers.setValue(false);
	}, [helpers]);

	return (
		<div className="flex gap-x-1">
			<label
				className={`flex gap-x-1 ${disabled ? 'cursor-default' : 'cursor-pointer'}`}
			>
				<input
					className="accent-rcrm-primary-blue"
					type="checkbox"
					checked={field.value || false}
					{...field}
					value={field.value || false}
					disabled={disabled}
				/>
				<p className="font-semibold text-base">{label}</p>
			</label>
		</div>
	);
};

export default Checkbox;
